




import { NavTabs } from '@tencent/wphk-ui';
import { defineComponent, computed } from '@vue/composition-api';
import { useRecordList, ListKind } from '../../store/record-list';
import { i18n } from '../../i18n';
import { biClick } from '@tencent/fit-bi-sdk';

export default defineComponent({
  components: {
    NavTabs,
  },
  setup() {
    // 注意此处kind不可以作为ref传入给nav-tabs组件，否则在nav-tabs内部也会响应其变化，再次触发change事件，导致两次请求
    const { setKind, kind } = useRecordList();

    const list = computed(() => [
      {
        id: ListKind.Store,
        name: i18n('已儲印花'),
        actived: kind === ListKind.Store,
      },
      {
        id: ListKind.Exchange,
        name: i18n('已兌印花'),
        actived: kind === ListKind.Exchange,
      },
    ]);

    const handleChange = (tab) => {
      setKind(tab.id);
      biClick('estamp-record.tab_click|印花记录页面顶部tab点击', {
        ftype: tab.id,
      });
    };

    return { list, handleChange };
  },
});
